import React, {
    useMemo
} from "react";
import {
    AgGridReact
} from "ag-grid-react";
import aggridUtils
    from "../../../../../utils/aggrid-utils.js";
import {
    DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL
} from "../../../../../utils/ag-grid-columns-utils.js";
import {
    navigateHook
} from "../../../../../hooks/use-navigate.js";
import {
    garrisonLinkUrl
} from "../utils/garrison-utils.js";
import GarrisonLink
    from "./garrison-link.jsx";

const GarrisonPanicTable = ({rows = []}) => {
    const navigate = navigateHook();

    const columnDefs = useMemo(() => [
        {field: "dtStart", headerName: "Ativado", flex: 1, comparator: aggridUtils.agGridCompareDateTime},
        {field: "attendanceProtocol", headerName: "Atendimento", flex: 1, comparator: aggridUtils.agGridNumberYearComparator,
            cellRenderer: ({data, value}) => ( <GarrisonLink to={garrisonLinkUrl.attendance(data?.attendanceId)} navigate={navigate}>{value ?? ""}</GarrisonLink>),
        },
        {field: "dtAck", headerName: "Desativado", flex: 1, comparator: aggridUtils.agGridCompareDateTime},
        {field: "userAck", headerName: "Desativado por", flex: 1},
    ], [navigate]);

    return (
        <AgGridReact
            domLayout="autoHeight"
            rowData={rows}
            columnDefs={columnDefs}
            defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
            animateRows={false}
            suppressCellFocus={true}
            gridOptions={{localeText: aggridUtils.localization()}}
            theme={aggridUtils.generalTheme()}
            overlayNoRowsTemplate="Nenhum registro."
        />
    );
};

export default GarrisonPanicTable;
